import {noop} from '@benchling/js-utils';
import React from 'react';

import {Nav, NavItem, Page} from 'bulk-workflows/BulkWorkflowComponents';
import * as BulkTranslationActions from 'bulk-workflows/translation/BulkTranslationActions';
import {BulkTranslation} from 'bulk-workflows/translation/BulkTranslationConstants';
import BulkTranslationEditor from 'bulk-workflows/translation/BulkTranslationEditor';
import BulkTranslationStore from 'bulk-workflows/translation/BulkTranslationStore';
import DataConnector from 'connect/DataConnector';

interface BulkTranslationPageProps {
  bulkTranslation: BulkTranslation;
}

class BulkTranslationPageConnector extends DataConnector<{}, BulkTranslationPageProps> {
  override shouldSubscribeToRedux = false;
  override stores = [BulkTranslationStore];

  enhanceProps(): BulkTranslationPageProps {
    return {bulkTranslation: this.bulkTranslationStore().getBulkTranslation()};
  }
}

class BulkTranslationPage extends React.Component<BulkTranslationPageProps> {
  override componentDidMount(): void {
    BulkTranslationActions.reset();
  }

  override render(): JSX.Element {
    const {bulkTranslation} = this.props;
    return (
      <Page>
        <Nav header="Bulk translate DNA to AA">
          <NavItem isActive={true} onClick={noop}>
            Translate DNA
          </NavItem>
        </Nav>
        <BulkTranslationEditor bulkTranslation={bulkTranslation} />
      </Page>
    );
  }
}

export default BulkTranslationPageConnector.connect(BulkTranslationPage);
